import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import {
  NegotiationBeneficiaryRequest,
  QineticNegotiationApi,
} from "../../orchestrator-api-client";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

interface BeneficiaryRequestAction {
  beneficiary: NegotiationBeneficiaryRequest;
  offerId: string | undefined;
}
export const submitBeneficiary = createAsyncThunk<
  void,
  BeneficiaryRequestAction,
  ThunkApi
>("submitBeneficiary", async (args, { rejectWithValue }) => {
  try {
    const { beneficiary, offerId } = args;

    await new QineticNegotiationApi().saveBeneficiary(offerId!, beneficiary);
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Beneficiario",
      description:
        "Non siamo riusciti a salvare il tuo beneficiario.\n Puoi provare a rigenerare il codice o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
